import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LinkResponse } from '../../business-partner-support/services/business-partner.service';

@Injectable()
export class EndCustomerService {
    constructor(private http: HttpClient) {}

    checkPassword(password: string): Observable<boolean> {
        const url = `${environment.http.usersBaseUrl}users/check-user-password`;
        const body: CheckPasswordData = {
            password,
            type: 'consumer',
        };
        return this.http.post<{ valid: boolean }>(url, body).pipe(map((response) => response.valid));
    }

    createConsumerAccount(consumer: Consumer): Observable<HttpResponse<LinkResponse>> {
        if (consumer.address.houseNumber) {
            consumer.address.houseNumber = String(consumer.address.houseNumber);
        }

        if (consumer.address.postalCode) {
            consumer.address.postalCode = String(consumer.address.postalCode);
        }

        if (consumer?.address?.region) {
            consumer.address.region = String(consumer.address.region);
        }

        const url = `${environment.http.usersV2BaseUrl}users/consumer`;
        return this.http.post<LinkResponse>(url, consumer, { observe: 'response' });
    }

    validateAddress(address: Address): Observable<Address[]> {
        return this.http.post<Address[]>(`${environment.http.usersBaseUrl}users/check-address`, address);
    }
}

export interface Address {
    street?: string;
    houseNumber?: string;
    postalCode?: string;
    city?: string;
    countryCode?: string;
    region?: string;
}

export interface ConsumerName {
    title?: string;
    firstName: string;
    familyName: string;
}

export interface Consumer {
    loginId: string;
    documents: { id: string; accepted: boolean }[];
    optIn: boolean;
    appId: string;
    languageCode: string;
    gender?: 'MALE' | 'FEMALE' | 'OTHER';
    birthDate?: string;
    name: ConsumerName;
    address?: Address;
    password?: string;
    invitationId?: string;
    redirectLink?: string;
    token?: string;
}

export interface CheckPasswordData {
    password: string;
    type: 'consumer' | 'customer';
}
